/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PauseTaskCommand } from '../../models/pause-task-command';
import { PauseTaskCommandResult } from '../../models/pause-task-command-result';

export interface ApiTaskPauseTaskPut$Params {
      body?: PauseTaskCommand
}

export function apiTaskPauseTaskPut(http: HttpClient, rootUrl: string, params?: ApiTaskPauseTaskPut$Params, context?: HttpContext): Observable<StrictHttpResponse<PauseTaskCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiTaskPauseTaskPut.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PauseTaskCommandResult>;
    })
  );
}

apiTaskPauseTaskPut.PATH = '/api/Task/PauseTask';
